<template>
  <div class="box">
    <h5>Настройки</h5>

    <div class="my-4">
      <div>{{textAuth ? textAuth : 'Локальные данные авторизации'}}:</div>
      <div v-if="authData" class="info">
        <div
            v-for="(t, i) of authData.split('\n')"
            :key="`auth-data-${i}`"
            :style="`margin-left: ${t.search(/\S/) * 10}px;`"
        >{{t}}</div>
      </div>
      <div v-else>Данные отсутствуют</div>
      <button
          class="k-onboarding-button ob-orange"
          @click="loadAuthData"
      >Обновить</button>
      <button
          class="k-onboarding-button ob-orange"
          @click="resetAuthData"
      >Очистить</button>
    </div>

    <div class="my-4">
      <div>{{textRoute ? textRoute : 'Локальные данные навигации'}}:</div>
      <div v-if="routeData" class="info">
        <div
            v-for="(t, i) of routeData.split('\n')"
            :key="`route-data-${i}`"
            :style="`margin-left: ${t.search(/\S/) * 10}px;`"
        >{{t}}</div>
      </div>
      <div v-else>Данные отсутствуют</div>
      <button
          class="k-onboarding-button ob-orange"
          @click="loadRouteData"
      >Обновить</button>
      <button
          class="k-onboarding-button ob-orange"
          @click="resetRouteData"
      >Очистить</button>
    </div>

    <div class="my-4">
      <div>{{textSearch ? textSearch : 'Локальные данные поиска'}}:</div>
      <div v-if="searchParams" class="info">
        <div
            v-for="(t, i) of searchParams.split('\n')"
            :key="`search-params-${i}`"
            :style="`margin-left: ${t.search(/\S/) * 10}px;`"
        >{{t}}</div>
      </div>
      <div v-else>Данные отсутствуют</div>
      <div v-if="searchData">А также данные о рецептах {{searchData.length}} символов</div>
      <button
          class="k-onboarding-button ob-orange"
          @click="loadSearchData"
      >Обновить</button>
      <button
          class="k-onboarding-button ob-orange"
          @click="resetSearchData"
      >Очистить</button>
    </div>

  </div>
</template>

<script>
export default {
  name: "Settings",
  data: () => ({
    textAuth: '',
    textRoute: '',
    textSearch: '',
    authData: null,
    routeData: null,
    searchData: null,
    searchParams: null,
  }),
  mounted() {
    this.loadAuthData();
    this.loadRouteData();
    this.loadSearchData();
  },
  methods: {
    loadAuthData() {
      try {
        const data = window.localStorage.getItem('auth-data');
        if (!data) {
          this.authData = '';
        } else {
          this.authData = JSON.stringify(JSON.parse(data), null, 2);
        }
      } catch {
        this.authData = '';
      }
      this.textAuth = 'Локальные данные авторизации успешно загружены';
    },
    loadRouteData() {
      try {
        const data = window.localStorage.getItem('route-data');
        if (!data) {
          this.routeData = '';
        } else {
          this.routeData = JSON.stringify(JSON.parse(data), null, 2);
        }
      } catch {
        this.routeData = '';
      }
      this.textRoute = 'Локальные данные навигации успешно загружены';
    },
    loadSearchData() {
      try {
        const data = window.localStorage.getItem('search-data');
        if (!data) {
          this.searchData = '';
        } else {
          this.searchData = JSON.stringify(JSON.parse(data), null, 2);
        }
      } catch {
        this.searchData = '';
      }
      try {
        const data = window.localStorage.getItem('search-params');
        if (!data) {
          this.searchParams = '';
        } else {
          this.searchParams = JSON.stringify(JSON.parse(data), null, 2);
        }
      } catch {
        this.searchParams = '';
      }
      this.textSearch = 'Локальные данные поиска успешно загружены';
    },
    resetAuthData() {
      window.localStorage.removeItem('auth-data');
      this.loadAuthData();
      this.textAuth = 'Локальные данные авторизации успешно удалены';
    },
    resetRouteData() {
      window.localStorage.removeItem('route-data');
      this.loadRouteData();
      this.textRoute = 'Локальные данные навигации успешно удалены';
    },
    resetSearchData() {
      window.localStorage.removeItem('search-data');
      window.localStorage.removeItem('search-params');
      this.loadSearchData();
      this.textSearch = 'Локальные данные поиска успешно удалены';
    },
  }
}
</script>

<style scoped>
.box {
  margin-top: 20px;
  margin-left: 5%;
  margin-right: 5%;
  width: 90%;
}

.k-onboarding-button {
  padding-left: 20px;
  padding-right: 20px;
  margin: 4px;
}

.info {
  overflow-x: auto;
}

@media (max-width: 767.98px) {
  .box {
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
    width: calc(100% - 20px);
  }

  .k-onboarding-button {
    width: 100%;
    margin: 4px 0 4px 0;
  }
}
</style>
